import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const apiKeyState = atom({
  key: "apiKeyState",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
